export const FbSDK = 'https://connect.facebook.net/en_US/sdk.js';
export const GRAPHAPI_WABAS_ID_ROUTE = `phone_numbers?fields=display_phone_number&access_token=
${process.env.REACT_APP_FACEBOOK_BUSINESS_SYSTEM_USER_TOKEN}`;

